export const TOKEN_INFO_SESSION_STORAGE_KEY = "accessTokenInfo";
export const DEFAULT_DETECT_VOLUME = 100;
export const CALIBRATION_MIN_LOG_POWER = 40;
export const CALIBRATION_MAX_LOG_POWER = 90;
